import Tick from './Tick';
import Cross from './Cross';

export { Tick, Cross };
